import { render, staticRenderFns } from "./reauthentication.vue?vue&type=template&id=404980d7&scoped=true"
import script from "./reauthentication.vue?vue&type=script&lang=js"
export * from "./reauthentication.vue?vue&type=script&lang=js"
import style0 from "./reauthentication.vue?vue&type=style&index=0&id=404980d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404980d7",
  null
  
)

export default component.exports